import React, { useMemo } from 'react'
import { Box, Icon, Modal } from '@maui/elements'
import { PageLoading } from '../common/PageLoading'
import { maApiFetch } from '@/api/apis'
import { useQuery } from '@maui/react-query'
import { normalizeMalware } from '../../api/normalizers'
import { MalwareModalDetails } from '../details/MalwareDetails/MalwareModalDetails'

function MalwareModal({ ...modalProps }) {
  const {
    id,
    name
  } = modalProps
  const { data: malwareData, error, isLoading } = useQuery([`/api/v4/malware/${id}`], () => {
    return maApiFetch(`/api/v4/malware/${id}`)
  }, { refetchOnWindowFocus: false })

  const malware = useMemo(() => {
    if (!malwareData) return null
    return normalizeMalware(malwareData)
  }, [malwareData])

  return (
    <Modal {...modalProps} ariaHideApp={false}>
      <Modal.Header onClose={modalProps.onClose}>
        <Icon name='bug' size='lg' />
        <Modal.Title>{name.toUpperCase()}</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        {isLoading
          ? <PageLoading/>
          : <MalwareModalDetails malware={malware} />
        }
        {error && (
          <Box height={250}>
            Error loading malware details
          </Box>
        )}
      </Modal.Body>
    </Modal>
  )
}

export default MalwareModal
